(function ($) {

    var COOKIE_DAYS = 30;
    var COOKIE_PATH = '/';

    bindLanguageSelector();

    function bindLanguageSelector() {
        $('body')
            .on('show.bs.modal', '.modal-change-language', function (e) {
                var modal = $(e.target);
                onLanguageSelectorOpened(modal);
            })
            .on('click', '.modal-change-language .btn-primary, .modal-change-language .form-group input', function (e) {
                var modal = $(this).closest('.modal-change-language');
                onLanguageSelected(modal);
            });
    }

    function onLanguageSelectorOpened(modal) {
        var cookieName = modal.data('cookieName');
        if (!cookieName) return;

        Cookies.json = false;
        var language = Cookies.get(cookieName);
        modal.find('input').each(function () {
            var input = $(this);
            var selected = input.val() == language;
            input.prop('checked', selected);
        });
    }

    function onLanguageSelected(modal) {
        var cookieName = modal.data('cookieName');
        var queryParam = modal.data('queryParam');
        var language = modal.find('input:checked').val();
        if (!language) return;

        if (cookieName) {
            Cookies.json = false;
            Cookies.set(cookieName, language, { expires: COOKIE_DAYS, path: COOKIE_PATH });
        }

        if (queryParam) {
            var query = {};
            query[queryParam] = language;
            var url = $.fn.urlUtil.mergeQuery(window.location.href, query);
            window.location = url;
        } else {
            window.location.reload(true);
        }
    }

}(window.jQuery));


// Analytics

analytics.eventConfig.push(
    {
        "target": ".component.a01-breadcrumb",
        "codeId": "a01",
        "events": [
            {
                "eventTarget": ":not(.change-language) a[href]",
                "eventType": "click",
                "tags": {
                    "event": "navigation",
                    "componentId": "a01",
                    "componentName": "breadcrumb",
                    "eventType": "breadcrumb internal navigation click",
                    "elementType": "breadcrumb link",
                    "elementText": "",
                    "destinationUrl": ""
                }
            }
        ]
    },
    {
        "target": ".component.breadcrumb-back",
        "codeId": "a01",
        "events": [
            {
                "eventTarget": "a[href]",
                "eventType": "click",
                "tags": {
                    "event": "navigation",
                    "componentId": "a01",
                    "componentName": "breadcrumb",
                    "eventType": "breadcrumb internal navigation click",
                    "elementType": "breadcrumb link",
                    "elementText": "",
                    "destinationUrl": ""
                }
            }
        ]
    },
)